var exports = {
  "CodeView": "CodeView__zhactG",
  "Header": "Header__xjdtip",
  "Controls": "Controls__PLgZAJ",
  "Heading": "Heading__d_VP9Y",
  "KeyboardHelpHint": "KeyboardHelpHint__04YOr7",
  "Notice": "Notice__P59gNF",
  "Viewport": "Viewport__dLflR7",
  "SourceContainer": "SourceContainer__2uroZr",
  "ScrollSurface": "ScrollSurface__Xnkj4h",
  "StickyWindow": "StickyWindow__R9aIV8",
  "StickyOffset": "StickyOffset__EqyUbC",
  "Document": "Document__0BOqrr",
  "WindowChunks": "WindowChunks__IXMlqk",
  "WindowChunk": "WindowChunk__1h1RKs",
  "embedded": "embedded__L5egfI",
  "retained": "retained__KdGh0G",
  "unprepared": "unprepared__L5P6HM",
  "Source": "Source__MqYq9I",
  "showcase": "showcase__rxuD2O",
  "windowLocalSource": "windowLocalSource__DUwmYv",
  "ChunkSource": "ChunkSource__FZjgXr",
  "LineHighlight": "LineHighlight__H5LI2L",
  "FoldMarkers": "FoldMarkers__ukz_Jv",
  "FoldMarker": "FoldMarker__PPInji",
};

__webpack_require__.r(module.exports = exports);
